export interface AvailabilitySearchResponse {
  MicrositeName: string | null;
  TimeSlots: AvailabilitySearchTimeSlot[];
  Promotions: Promotion[];
  StandardAvailabilityMayRequireCreditCard: boolean;
}

export interface AvailabilitySearchTimeSlot {
  TimeSlot: string;
  IsLeaveTimeRequired?: boolean;
  LeaveTime?: string;
  ServiceId?: number;
  HasStandardAvailability?: boolean;
  AvailablePromotions?: AvailabilitySearchPromotion[];
  StandardAvailabilityFeeAmount?: number;
}

export interface AvailabilitySearchPromotion {
  Id: number;
  FeeAmount: number;
  LeaveTime: string;
  BasePrice: number;
}

export interface Promotion {
  Id: number;
  Name: string;
  Description: string;
  MayRequireCreditCard: boolean;
  ValidityPeriods: ValidityPeriod[];
  FullPrice: number | null;
  MenuVersionId: number | null;
  MenuName: string | null;
  MenuUrl: string | null;
  TakeawayType: number | null;
}

export interface ValidityPeriod {
  StartDate: string;
  EndDate: string;
  StartTime: string;
  EndTime: string;
  Frequency: DayOfWeek[];
  IsAlwaysApply: boolean;
  DayVariables: DayVariable[];
}

export enum DayOfWeek {
  Sunday = "Sunday",
  Monday = "Monday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
  Thursday = "Thursday",
  Friday = "Friday",
  Saturday = "Saturday",
}

export interface DayVariable {
  DayOfWeek: DayOfWeek;
  Price: number | null;
}
